import React, { useEffect, useState } from 'react'
import { ProgressBar } from 'react-bootstrap'
import './MeetingProgressDisplay.scss'

export interface MeetingProgressDisplayProps {
  startedAtTime: number
  duration: number
}

export const MeetingProgressDisplay: React.FC<MeetingProgressDisplayProps> = ({ startedAtTime, duration }) => {
  const [now, setNow] = useState<number>()

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date().getTime()
      setNow(currentTime - startedAtTime)
    }, 1000)
    return () => clearTimeout(interval)
  }, [startedAtTime])

  return (
    <div>
      <ProgressBar max={duration} now={now} striped={true} animated={true} />
    </div>
  )
}
